<template>
  <v-dialog
    v-model="visibility"
    max-width="500"
    persistent
  >
    <v-card>
      <v-alert
        v-model="error"
        dismissible
        type="error"
      >
        {{errorMsg}}
      </v-alert>

      <div class="px-0">

        <v-card-title class="headline py-2 pr-2">
          Szczegóły
          <v-spacer></v-spacer>
          <v-btn
            @click.native="visibility = false"
            icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>
        <div v-if="!dialogBusy">
          <div class="scrollable-height">
            <div class="py-4">
              <div class="pb-2 pt-2">
                <div class="px-4 pb-4 font-weight-medium">
                  <v-icon v-if="mimeType" :color="mimeType.color" class="mr-2" size="20">
                    {{mimeType.icon}}
                  </v-icon>
                  {{dialogVisibility.name}}
                </div>
                <v-layout class="px-4 pb-2" v-if="details.created_at" wrap>
                  <v-flex xs12 sm5>
                    <span class="body-2 grey--text">Utworzono:</span>
                  </v-flex>
                  <v-flex xs12 sm7>
                    {{details.created_at}}
                  </v-flex>
                </v-layout>

                <v-layout class="px-4 pb-2" v-if="details.last_modified_at" wrap>
                  <v-flex xs12 sm5>
                    <span class="body-2 grey--text">Zmodyfikowany:</span>
                  </v-flex>
                  <v-flex xs12 sm7>
                    {{details.last_modified_at}}
                  </v-flex>
                </v-layout>

                <v-layout class="px-4 pb-2" v-if="details.owner_name" wrap>
                  <v-flex xs12 sm5>
                    <span class="body-2 grey--text">Właściciel:</span>
                  </v-flex>
                  <v-flex xs12 sm7>
                    {{details.owner_name}}
                  </v-flex>
                </v-layout>
              </div>
              <div class="pt-4 pb-2">
                <v-layout class="px-4 pb-2" v-if="details.size" wrap>
                  <v-flex xs12 sm5>
                    <span class="body-2 grey--text">Rozmiar:</span>
                  </v-flex>
                  <v-flex xs12 sm7>
                    {{details.size}}
                  </v-flex>
                </v-layout>

                <v-layout class="px-4 pb-2" v-if="details.extension" wrap>
                  <v-flex xs12 sm5>
                    <span class="body-2 grey--text">Typ pliku:</span>
                  </v-flex>
                  <v-flex xs12 sm7>
                    {{details.extension.toUpperCase()}}
                  </v-flex>
                </v-layout>

                <v-layout class="px-4 pb-2"
                    v-if="typeof details.directories_count !== 'undefined'" wrap>
                  <v-flex xs12 sm5>
                    <span class="body-2 grey--text">Liczba plików:</span>
                  </v-flex>
                  <v-flex xs12 sm7>
                    {{details.files_count}}
                  </v-flex>
                </v-layout>

                <v-layout class="px-4" v-if="typeof details.directories_count !== 'undefined'" wrap>
                  <v-flex xs12 sm5>
                    <span class="body-2 grey--text">Liczba katalogów:</span>
                  </v-flex>
                  <v-flex xs12 sm7>
                    {{details.directories_count}}
                  </v-flex>
                </v-layout>
                <v-layout class="px-4"
                  v-if="details.tags && details.tags.length > 0"
                  wrap
                >
                  <v-flex xs12 sm5>
                    <span class="body-2 grey--text">Tagi:</span>
                  </v-flex>
                  <v-flex xs12 sm7>
                    <v-chip
                      small
                      v-for="(tag, index) in details.tags"
                      :key="index"
                      text-color="white"
                      class="ml-0 mr-2"
                      :style="{backgroundColor: tag.color_hex}"
                    >{{tag.name}}</v-chip>
                  </v-flex>
                </v-layout>
              </div>

              <div class="pt-4"
                 v-if="details.users_limited_access && details.users_limited_access.length > 0
                || details.users_full_access && details.users_full_access.length > 0
              ">
                <v-layout class="px-4 pb-2"
                  v-if="details.users_full_access && details.users_full_access.length > 0"
                  wrap
                >
                  <v-flex xs12 sm5>
                    <span class="body-2 grey--text">Pełny dostęp:</span>
                  </v-flex>
                  <v-flex xs12 sm7>
                <span
                  v-for="(user, index) in details.users_full_access"
                  :key="index"
                >{{user.first_name}} {{user.last_name}}<br/></span>
                  </v-flex>
                </v-layout>

                <v-layout class="px-4 pb-2"
                  v-if="details.users_limited_access
                  && details.users_limited_access.length > 0"
                  wrap
                >
                  <v-flex xs12 sm5>
                    <span class="body-2 grey--text">Ograniczony dostęp:</span>
                  </v-flex>
                  <v-flex xs12 sm7>
                <span
                  v-for="(user, index) in details.users_limited_access"
                  :key="index"
                >{{user.first_name}} {{user.last_name}}<br/></span>
                  </v-flex>
                </v-layout>
              </div>
            </div>
          </div>
          <v-divider></v-divider>
          <v-card-actions class="px-4 py-4">
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              :loading="busy"
              :disabled="busy"
              @click="setVisbility"
            >
              Zamknij
            </v-btn>
          </v-card-actions>
        </div>
        <div v-if="dialogBusy">
          <div class="py-4 text-xs-center">
            <v-progress-circular
              :size="30"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getDirectoryDetails, getFileDetails } from './../../../repository/files';
import { getError, getMimeTypeData } from '../../../helpers/helpers';

export default {
  name: 'details-dialog',
  data: () => ({
    busy: false,
    errorMsg: null,
    error: null,
    details: null,
    dialogBusy: true,
  }),
  computed: {
    ...mapGetters('files', [
      'dialogVisibility',
    ]),
    mimeType() {
      return getMimeTypeData(this.dialogVisibility.extension);
    },
    type() {
      return this.dialogVisibility.fileType;
    },
    visibility: {
      get() {
        return this.dialogVisibility.type === 'details';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
  },
  methods: {
    ...mapActions('files', [
      'setDialogVisbility',
    ]),
    setVisbility() {
      this.setDialogVisbility(false);
    },
    getError(errorData) {
      this.dialogBusy = false;
      this.busy = false;
      this.errorMsg = getError(errorData);
      this.error = true;
    },
    async getDetails() {
      this.dialogBusy = true;
      const fileId = this.dialogVisibility.id;
      try {
        let details;
        if (this.type === 1) {
          details = await getDirectoryDetails(fileId);
          this.details = details.data.data.directory;
        } else {
          details = await getFileDetails(fileId);
          this.details = details.data.data.file;
        }
        this.dialogBusy = false;
      } catch (e) {
        this.getError(e);
      }
    },
  },
  watch: {
    visibility(val) {
      if (val) {
        this.getDetails();
      }
    },
  },
};
</script>
